import {
  Stack
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { Glasses, Timer } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  InfoTypography,
  TopicCardSignatureStack
} from "./TopicCardSignature.styles";
import type { TopicCardSignatureProps } from "./TopicCardSignature.types";

export function TopicCardSignature({
  color,
  created,
  isModified,
  readingTime,
  size,
  hideIcon = false,
  ...props
}: TopicCardSignatureProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <TopicCardSignatureStack
      flexGrow={ 1 }
      { ...props }
    >

      {
        created ?
          <Stack
            alignItems={ "center" }
            direction={ "row" }
            gap={ "4px" }>
            { !hideIcon &&
              <Timer
                size={ "24px" }
                color={ color || theme.customColors.textDisabledAlternative }
              />
            }
            <InfoTypography
              color={ color || theme.customColors.textDisabledAlternative }
              fontSize={ "12px" }
            >
              { created }
            </InfoTypography>

            {
              isModified ?
                <InfoTypography
                  color={ color || theme.customColors.textDisabledAlternative }
                  fontSize={ "12px" }
                >
                  {  "( " +  t("modified") + " )" }
                </InfoTypography>
                : null
            }
          </Stack> : null
      }

      {
        readingTime ?
          <Stack
            alignItems={ "center" }
            direction={ "row" }
            gap={ 1 }
          >
            <Glasses
              color={ color || theme.customColors.textDisabledAlternative }
              size={ "24px" }
            />
            <InfoTypography
              color={ color || theme.customColors.textDisabledAlternative }
              fontSize={ "12px" }
            >
              { readingTime }
            </InfoTypography>
          </Stack> :
          null
      }
    </TopicCardSignatureStack>
  );

}
